import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        fontFamily:
          "system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
        lineHeight: "1.6",
        color: "#111",
        padding: "28px",
        maxWidth: "900px",
        margin: "0 auto",
      }}
    >
      <header>
        <h1 style={{ color: "#0b3b6f" }}>Privacy Policy</h1>
        <p style={{ marginBottom: "8px", color: "#666" }}>
          Last updated: June 23, 2026
        </p>
        <p style={{ fontSize: "0.9rem", color: "#555" }}>
          This Privacy Policy explains how Aeonian Technology Corporation
          ("we", "our", "us") collects, uses, discloses, and safeguards your
          personal information across the Aeon platform, including the Aeon
          Parent app, the Aeon Driver app, and our web dashboards (the
          "Services").
        </p>
      </header>

      <main>
        <h2 style={{ color: "#0b3b6f" }}>Scope</h2>
        <p>
          This policy applies to all users of the Services — parents,
          students' guardians, drivers, schools, and vendors — across the
          Aeon Parent app, the Aeon Driver app, and our web platform. It
          covers personal information (not aggregated or anonymized data).
        </p>

        <h2 style={{ color: "#0b3b6f" }}>Information We Collect</h2>
        <ul>
          <li>
            <strong>Information you provide:</strong>
            <ul>
              <li>
                <em>Aeon Parent:</em> name, email, phone number, home
                address, payment/billing information, your children's
                names and grade level, and an optional profile photo.
              </li>
              <li>
                <em>Aeon Driver:</em> name, email, phone number, home
                address, profile photo, driver's license number, and
                driver's license front/back images for verification.
              </li>
            </ul>
          </li>
          <li>
            <strong>Location data:</strong>
            <ul>
              <li>
                <em>Aeon Parent:</em> with your permission, we access your
                device's precise location only while you are actively using
                the "Update Address" feature, to auto-fill your home address
                for accurate student pickup/drop-off. This is a one-time,
                in-the-moment read — we do not collect your location in the
                background.
              </li>
              <li>
                <em>Aeon Driver:</em> with your permission, we access your
                device's precise location while you are on an active,
                started ride — including while the app is in the background
                — so that route progress, pickup, and drop-off status can be
                shared in real time with parents and the school. Background
                location collection stops once the ride ends.
              </li>
            </ul>
          </li>
          <li>
            <strong>Communications:</strong> in-app messages between
            parents, drivers, schools, and vendors are stored on our
            servers; push and email notifications are sent through
            third-party providers (e.g. Firebase Cloud Messaging) and we may
            log delivery metadata.
          </li>
          <li>
            <strong>From others:</strong> driver background-check providers,
            payment processors, partner schools/vendors, and linked
            enterprise programs.
          </li>
        </ul>

        <h2 style={{ color: "#0b3b6f" }}>How We Use Your Information</h2>
        <p>
          We use data to operate and improve the service, verify identity,
          process payments, provide customer support, maintain safety, and
          comply with legal obligations.
        </p>

        <h2 style={{ color: "#0b3b6f" }}>How We Share Information</h2>
        <p>We do not sell personal information. We may share data:</p>
        <ul>
          <li>
            Between Aeon Parent and Aeon Driver users as needed to provide
            the service (e.g., a student's pickup/drop-off address and live
            location is shared with the assigned driver and the student's
            parent; a driver's name, vehicle, and live location is shared
            with the parents and school on that route).
          </li>
          <li>
            With the school or vendor managing the reservation, so they can
            coordinate transportation.
          </li>
          <li>
            With service providers to process payments, verify identity, and
            provide analytics.
          </li>
          <li>
            To comply with legal requests or to protect rights and safety.
          </li>
          <li>During mergers or asset sales, as permitted by law.</li>
        </ul>

        <h2 style={{ color: "#0b3b6f" }}>Data Retention & Security</h2>
        <p>
          We retain data as necessary to provide services, meet legal
          obligations, and for legitimate business needs (transaction records
          kept at least 7 years where applicable). We implement reasonable
          security controls but cannot guarantee 100% security.
        </p>

        <h2 style={{ color: "#0b3b6f" }}>Your Rights & Choices</h2>
        <ul>
          <li>Access and edit profile data via account settings.</li>
          <li>
            Opt-out of promotional emails and texts via the methods described in
            account communications.
          </li>
          <li>
            Delete your account via the privacy homepage; certain records may be
            retained for legal or business reasons.
          </li>
          <li>
            Control device location sharing via device settings (note: disabling
            may limit functionality).
          </li>
        </ul>

        <h2 style={{ color: "#0b3b6f" }}>Children</h2>
        <p>
          We do not knowingly collect personal data from children under 16. If
          discovered, we will take steps to delete such data.
        </p>

        <h2 style={{ color: "#0b3b6f" }}>Changes to this Policy</h2>
        <p>
          We may update this policy; material changes will be communicated via
          the app or email. Continued use implies acceptance of the updated
          policy.
        </p>

        <h2 style={{ color: "#0b3b6f" }}>Contact</h2>
        <p>
          If you have questions about privacy or need this policy in another
          format, contact Aeonian Technology Corporation. Please visit our{" "}
          <a
            href="https://aeon-app.com/support/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#0b3b6f", textDecoration: "underline", fontWeight: 600 }}
          >
            Support page
          </a>{" "}
          to reach us via our contact form, email, or phone, or to find our
          mailing address.
        </p>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
